(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[285],{

/***/ 50929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hr-as-a-service",
      function () {
        return __webpack_require__(43728);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ FormSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/Select.tsx
var Select = __webpack_require__(2679);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./components/form/FormSelect/FormSelect.tsx






var FormSelect = function(param) {
    var name = param.name, options = param.options, _formGroup = param.formGroup, formGroup = _formGroup === void 0 ? {} : _formGroup, _input = param.input, input = _input === void 0 ? {} : _input;
    var ref, ref1;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), control = ref2.control, errors = ref2.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formGroup), {
        error: errors === null || errors === void 0 ? void 0 : (ref = errors[name]) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        forId: name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: name,
            render: function(param) {
                var field = param.field;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    id: name,
                    options: options,
                    type: "text",
                    variant: (errors === null || errors === void 0 ? void 0 : errors[name]) ? "error" : ""
                }, input, field), {
                    value: field.value || ""
                }));
            }
        })
    }));
};

;// CONCATENATED MODULE: ./components/form/FormSelect/index.ts



/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 43728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ hr_as_a_service; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../ui-common/dist/index.js + 26 modules
var dist = __webpack_require__(49976);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/HrAsAServicePage.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n\n  @media (max-width: ",
        ") {\n    padding: 0 1.5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb724434-0"
})(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb724434-1"
})(_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* screen */.sp)("xl"));

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var ui_library_dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/evaluate/Evaluate.styled.ts

function Evaluate_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        " 0;\n  color: #fff;\n"
    ]);
    Evaluate_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Evaluate_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 55rem;\n  margin: auto;\n\n  h3 {\n    margin-top: 1.5rem;\n  }\n\n  p {\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n  }\n\n  span[mode='light'] {\n    background: #fff;\n  }\n"
    ]);
    Evaluate_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Evaluate_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e02dbc8-0"
})(Evaluate_styled_templateObject(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* spacing */.W0)("xl4"));
var Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e02dbc8-1"
})(Evaluate_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/evaluate/Evaluate.tsx







var Evaluate = function() {
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Evaluate_styled_Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Badge */.Ct, {
                        bold: true,
                        schema: "neutral",
                        label: t("hr-as-a-service.evaluate.badge"),
                        variant: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                        as: "h3",
                        size: "5xl",
                        editorial: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "hr-as-a-service",
                            i18nKey: "hr-as-a-service.evaluate.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "hr-as-a-service",
                        i18nKey: "hr-as-a-service.evaluate.desc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                        variant: "hard",
                        schema: "brand2",
                        startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                        label: t("hr-as-a-service.evaluate.cta"),
                        href: "https://getmanfred.typeform.com/to/ghpHTBB1",
                        target: "_blank"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/evaluate/index.ts


// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/evaluate-box/EvaluateBox.styled.ts

function EvaluateBox_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        ";\n  color: #fff;\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  border-radius: 10px;\n  max-width: 20rem;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n"
    ]);
    EvaluateBox_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EvaluateBox_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0;\n  background: none;\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  cursor: pointer;\n  top: 1rem;\n  right: 1rem;\n\n  svg {\n    color: white;\n  }\n"
    ]);
    EvaluateBox_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: auto;\n\n  p {\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var EvaluateBox_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6148ff2e-0"
})(EvaluateBox_styled_templateObject(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* spacing */.W0)("xl"));
var Close = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-6148ff2e-1"
})(EvaluateBox_styled_templateObject1());
var EvaluateBox_styled_Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6148ff2e-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/evaluate-box/EvaluateBox.tsx








var EvaluateBox = function(param) {
    var onClick = param.onClick;
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EvaluateBox_styled_Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
                    onClick: onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Icon */.JO, {
                        icon: pro_light_svg_icons/* faTimes */.NBC,
                        size: "xl"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EvaluateBox_styled_Intro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                            as: "h3",
                            size: "3xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.evaluate.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "hr-as-a-service",
                            i18nKey: "hr-as-a-service.evaluate.desc"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                            variant: "hard",
                            schema: "brand2",
                            startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                            label: t("hr-as-a-service.evaluate.cta"),
                            href: "https://getmanfred.typeform.com/to/ghpHTBB1",
                            target: "_blank"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/evaluate-box/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ./components/form/FormCheckbox/index.ts + 1 modules
var FormCheckbox = __webpack_require__(74806);
// EXTERNAL MODULE: ./components/form/FormPhone/index.ts + 1 modules
var FormPhone = __webpack_require__(72109);
// EXTERNAL MODULE: ./components/form/FormSelect/index.ts + 1 modules
var FormSelect = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/form/FormText/FormText.tsx
var FormText = __webpack_require__(78712);
// EXTERNAL MODULE: ./components/form/FormTextarea/index.ts + 1 modules
var FormTextarea = __webpack_require__(13573);
// EXTERNAL MODULE: ./components/HashAnchor/index.ts + 2 modules
var HashAnchor = __webpack_require__(40176);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./features/portal/v2/contact/basic-info/ContactBasicInfo.constants.ts
var ContactBasicInfo_constants = __webpack_require__(18032);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod = __webpack_require__(33161);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.deal.ts
var service_deal = __webpack_require__(75399);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ../api-common/dist/esm/index.js + 114 modules
var dist_esm = __webpack_require__(25465);
// EXTERNAL MODULE: ../utils/dist/esm/index.js + 3 modules
var utils_dist_esm = __webpack_require__(74679);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/form/Form.constants.ts




var I18N_PREFIX = "hr-as-a-service";
var DEFAULT_TYPE_OPTION = {
    label: "SELECT_ONE",
    value: ""
};
var ConsultancyFormFieldsSchema = lib.z.object({
    name: lib.z.string(),
    email: lib.z.string(),
    description: lib.z.string(),
    company: lib.z.string(),
    contactPhone: lib.z.string().optional(),
    terms: lib.z.boolean().optional(),
    howDoYouKnowUs: lib.z["enum"](dist_esm/* howDoYouKnowUsValues */.TwG),
    isSubscribeToNewsletter: lib.z.boolean(),
    packages: lib.z.array(lib.z.string())
});
var ConsultancyFormFieldsValidationSchema = ConsultancyFormFieldsSchema.partial()// Name required
.refine(function(schema) {
    return !!schema.name;
}, {
    path: [
        "name"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.required-name"), {
        ns: I18N_PREFIX
    })
})// Email required
.refine(function(schema) {
    return !!schema.email;
}, {
    path: [
        "email"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.required-email"), {
        ns: I18N_PREFIX
    })
})// Email format
.refine(function(schema) {
    var ref;
    return (ref = schema.email) === null || ref === void 0 ? void 0 : ref.match(utils_dist_esm/* EMAIL_REGEX */.CU);
}, {
    path: [
        "email"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.invalid-email"), {
        ns: I18N_PREFIX
    })
})// Description required
.refine(function(schema) {
    return !!schema.description;
}, {
    path: [
        "description"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.required-description"), {
        ns: I18N_PREFIX
    })
})// How do you know us required
.refine(function(schema) {
    return !!schema.howDoYouKnowUs;
}, {
    path: [
        "howDoYouKnowUs"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.required-how-do-you-know-us"), {
        ns: I18N_PREFIX
    })
})// company required
.refine(function(schema) {
    return !!schema.company;
}, {
    path: [
        "company"
    ],
    message: esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.t */.ag.t("".concat(I18N_PREFIX, ".form.required-company"), {
        ns: I18N_PREFIX
    })
});
var FORM_FIELDS_DEFAULT_VALUES = {
    name: "",
    email: "",
    description: "",
    company: "",
    contactPhone: "",
    howDoYouKnowUs: undefined,
    isSubscribeToNewsletter: false,
    packages: []
};

// EXTERNAL MODULE: ../../node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(17473);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/form/Form.hooks.ts














var useConsultancyForm = function() {
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,useToasts/* useToasts */.e)(), addErrorToast = ref.addErrorToast, addSuccessToast = ref.addSuccessToast;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: FORM_FIELDS_DEFAULT_VALUES,
        resolver: (0,zod/* zodResolver */.F)(ConsultancyFormFieldsValidationSchema)
    });
    var isTermsAccepted = !!formMethods.watch("terms");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var recaptchaToken, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!executeRecaptcha) {
                            console.error("Recaptcha not available");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            executeRecaptcha("hr_as_a_service_form")
                        ];
                    case 1:
                        recaptchaToken = _state.sent();
                        return [
                            4,
                            service_deal/* ServiceDeal.create */.a.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                howDoYouKnowUs: data.howDoYouKnowUs || "OTHER",
                                consultingOptions: data.packages || [],
                                source: "Manfred Web - Consulting",
                                recaptchaToken: recaptchaToken
                            }))
                        ];
                    case 2:
                        _state.sent();
                        formMethods.reset(FORM_FIELDS_DEFAULT_VALUES);
                        addSuccessToast(t("hr-as-a-service.form.success"));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        console.error("There was an error while submitting the Consultancy form. Form data: ".concat(data, ". Exception: ").concat(ex));
                        addErrorToast(t("hr-as-a-service.form.error"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addErrorToast,
        addSuccessToast,
        formMethods,
        executeRecaptcha,
        t
    ]);
    var onFormFieldFocus = (0,react.useCallback)(function() {
        service_event_tracking/* default.track */.Z.track({
            type: "Landing - Form Focused",
            properties: {
                objectName: "contacto-empresas",
                url: window.location.href,
                urlParams: new URLSearchParams(window.location.search).toString()
            }
        });
    }, []);
    return {
        t: t,
        locale: locale,
        formMethods: formMethods,
        onSubmit: onSubmit,
        isTermsAccepted: isTermsAccepted,
        onFormFieldFocus: onFormFieldFocus
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/form/Form.styled.tsx

function Form_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  position: relative;\n  overflow: hidden;\n\n  span.neutral,\n  span.active {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  span.neutral {\n    background: #fff;\n\n    &:hover {\n      border-color: #888;\n    }\n  }\n"
    ]);
    Form_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Form_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n  max-width: 40rem;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n\n  .phoneNumber {\n    max-width: 20rem;\n  }\n"
    ]);
    Form_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Form_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n  font-size: ",
        ";\n\n  line-height: 1.5;\n\n  h2 {\n    line-height: 1.15;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    Form_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.333;\n\n  a {\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n    }\n\n    &:active {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: absolute;\n  inset: 0;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n\n  .astronaut {\n    object-fit: contain;\n    margin-top: auto;\n    height: 32rem;\n    margin-right: -3rem;\n    margin-bottom: 2rem;\n    transform: translateY(0);\n    animation: float 6s ease-in-out infinite;\n  }\n\n  .planet {\n    object-fit: contain;\n    height: 15.625rem;\n    transform: translateY(0);\n    margin-left: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  @keyframes float {\n    0% {\n      transform: translateY(0);\n    }\n    50% {\n      transform: translateY(20px);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-db40c474-0"
})(Form_styled_templateObject(), (0,theme/* color */.$_)("indigo_900"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var StyledContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-db40c474-1"
})(Form_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-db40c474-2"
})(Form_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledTerms = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-db40c474-3"
})(_templateObject3(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"));
var StyledHeroImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-db40c474-4"
})(_templateObject4(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/form/Form.utils.ts





var getTypeOptions = function(t) {
    var options = dist_esm/* howDoYouKnowUsValues.map */.TwG.map(function(h) {
        return {
            label: h,
            value: h
        };
    });
    return [
        DEFAULT_TYPE_OPTION
    ].concat((0,_to_consumable_array/* default */.Z)(options)).map(function(type) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, type), {
            label: t("hr-as-a-service.form.how-do-you-know-us-values.".concat(type.label))
        });
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/form/Form.tsx
























var Form = function() {
    var ref = useConsultancyForm(), t = ref.t, formMethods = ref.formMethods, locale = ref.locale, onSubmit = ref.onSubmit, isTermsAccepted = ref.isTermsAccepted, onFormFieldFocus = ref.onFormFieldFocus;
    var control = formMethods.control, handleSubmit = formMethods.handleSubmit, isSubmitting = formMethods.formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                name: "hrForm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                                as: "h2",
                                size: "4xl",
                                editorial: true,
                                children: t("hr-as-a-service.form.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.form.desc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                label: t("hr-as-a-service.form.packages"),
                                forId: "packages",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "packages",
                                    render: function(param) {
                                        var field = param.field;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_library_dist/* Stack */.Kq, {
                                            gap: "m",
                                            wrap: true,
                                            children: Array.from(Array(8).keys()).map(function(_, index) {
                                                var ref, ref1, ref2;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_library_dist/* Badge */.Ct, {
                                                    bold: true,
                                                    variant: "white",
                                                    size: "s",
                                                    className: ((ref = field.value) === null || ref === void 0 ? void 0 : ref.includes(t("hr-as-a-service.form.package".concat(index + 1)))) ? "active" : "neutral",
                                                    schema: ((ref1 = field.value) === null || ref1 === void 0 ? void 0 : ref1.includes(t("hr-as-a-service.form.package".concat(index + 1)))) ? "active" : "neutral",
                                                    icon: ((ref2 = field.value) === null || ref2 === void 0 ? void 0 : ref2.includes(t("hr-as-a-service.form.package".concat(index + 1)))) ? pro_solid_svg_icons/* faCheck */.LEp : undefined,
                                                    onClick: function() {
                                                        var ref, ref1;
                                                        return field.onChange(((ref = field.value) === null || ref === void 0 ? void 0 : ref.includes(t("hr-as-a-service.form.package".concat(index + 1)))) ? (ref1 = field.value) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                                            return v !== t("hr-as-a-service.form.package".concat(index + 1));
                                                        }) : (0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)(field.value || []).concat([
                                                            t("hr-as-a-service.form.package".concat(index + 1))
                                                        ]))));
                                                    },
                                                    label: t("hr-as-a-service.form.package".concat(index + 1))
                                                }, index);
                                            })
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                name: "name",
                                formGroup: {
                                    label: t("hr-as-a-service.form.name")
                                },
                                input: {
                                    placeholder: t("hr-as-a-service.form.name_placeholder"),
                                    onFocus: onFormFieldFocus
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                name: "email",
                                formGroup: {
                                    label: t("hr-as-a-service.form.email")
                                },
                                input: {
                                    placeholder: t("hr-as-a-service.form.email_placeholder"),
                                    onFocus: onFormFieldFocus
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "phoneNumber",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormPhone/* FormPhone */.J, {
                                    name: "contactPhone",
                                    formGroup: {
                                        label: t("hr-as-a-service.form.phone")
                                    },
                                    input: {
                                        defaultCountry: ContactBasicInfo_constants/* PHONE_NUMBER_DEFAULT_COUNTRY */.r,
                                        onFocus: onFormFieldFocus
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                name: "company",
                                formGroup: {
                                    label: t("hr-as-a-service.form.company")
                                },
                                input: {
                                    placeholder: t("hr-as-a-service.form.company_placeholder"),
                                    onFocus: onFormFieldFocus
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* FormSelect */.i, {
                                name: "howDoYouKnowUs",
                                formGroup: {
                                    label: t("hr-as-a-service.form.how-do-you-know-us")
                                },
                                options: getTypeOptions(t)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextarea/* FormTextarea */.B, {
                                name: "description",
                                formGroup: {
                                    label: t("hr-as-a-service.form.description")
                                },
                                input: {
                                    placeholder: t("hr-as-a-service.form.description_placeholder"),
                                    onFocus: onFormFieldFocus,
                                    rows: 3
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                                name: "terms",
                                input: {
                                    onFocus: onFormFieldFocus,
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTerms, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                            ns: "hr-as-a-service",
                                            i18nKey: "hr-as-a-service.form.terms",
                                            components: {
                                                privatePolicy: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy, locale)
                                                }),
                                                terms: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse, locale)
                                                })
                                            }
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckbox/* FormCheckbox */.z, {
                                name: "isSubscribeToNewsletter",
                                input: {
                                    onFocus: onFormFieldFocus,
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTerms, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                            ns: "hr-as-a-service",
                                            i18nKey: "hr-as-a-service.form.newsletter",
                                            components: {
                                                newsletter: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://none.clickacm.com/show/qgJ2lZXPBBizIfJi3pmS/",
                                                    target: "_blank"
                                                })
                                            }
                                        })
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Button */.zx, {
                                schema: "brand2",
                                label: t("hr-as-a-service.form.submit"),
                                startIcon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                type: "submit",
                                disabled: !isTermsAccepted,
                                isLoading: isSubmitting,
                                loadingText: t("hr-as-a-service.form.submit_in-progress")
                            })
                        ]
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroImage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/consultancy/planet.svg"),
                        alt: "",
                        className: "planet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/consultancy/astronaut.svg"),
                        alt: "",
                        className: "astronaut"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/form/index.ts


// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/help/Help.styled.ts

function Help_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        " 0;\n"
    ]);
    Help_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Help_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 40rem;\n  margin: auto;\n\n  h3 {\n    margin-bottom: 0;\n  }\n\n  p {\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    Help_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Help_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    Help_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Help_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Help_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Help_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: #fff;\n  padding: 4rem;\n  border-radius: 10px;\n  margin-bottom: 1.5rem;\n\n  h4 {\n  }\n\n  p {\n    font-size: 1.25rem;\n  }\n\n  .items {\n    flex: 1 0 45%;\n    width: 45%;\n\n    ul,\n    li {\n      margin: 0;\n      padding: 0;\n\n      img {\n        height: 64px;\n        width: 64px;\n      }\n    }\n\n    ul {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      column-gap: 1.25rem;\n      row-gap: 1.25rem;\n\n      @media (max-width: ",
        ") {\n        display: flex;\n        flex-direction: column;\n        gap: 1.25rem;\n      }\n    }\n\n    li {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n    }\n  }\n"
    ]);
    Help_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Help_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6c3533-0"
})(Help_styled_templateObject(), (0,theme/* color */.$_)("sun_100"), (0,theme/* spacing */.W0)("xl3"));
var Help_styled_Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6c3533-1"
})(Help_styled_templateObject1());
var CTA = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6c3533-2"
})(Help_styled_templateObject2());
var Features = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6c3533-3"
})(Help_styled_templateObject3());
var Feature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6c3533-4"
})(Help_styled_templateObject4(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* screen */.sp)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/help/Help.tsx











var Help = function() {
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    var features = [
        {
            items: 6
        },
        {
            items: 6
        },
        {
            items: 4
        },
        {
            items: 4
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Help_styled_Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Help_styled_Intro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                            as: "h3",
                            size: "5xl",
                            editorial: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.help.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "hr-as-a-service",
                            i18nKey: "hr-as-a-service.help.desc"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {
                    children: features.map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                                    name: "help-feature".concat(index + 1)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* Stack */.Kq, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                                                    as: "h4",
                                                    size: "4xl",
                                                    editorial: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "hr-as-a-service",
                                                        i18nKey: "hr-as-a-service.help.feature".concat(index + 1, ".title")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "hr-as-a-service",
                                                    i18nKey: "hr-as-a-service.help.feature".concat(index + 1, ".desc")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                    to: "hrForm",
                                                    href: "#hrForm",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                                                        variant: "hard",
                                                        schema: "brand2",
                                                        size: "xs",
                                                        endIcon: pro_light_svg_icons/* faArrowRight */.eFW,
                                                        label: t("hr-as-a-service.help.item-cta"),
                                                        href: "#hrForm"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* StackItem */.vO, {
                                            className: "items",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: Array.from(Array(feature.items).keys()).map(function(_, j) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: (0,paths/* getPublicPath */.A)("/images/hr-as-a-service/item".concat(index + 1, ".svg"))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                                ns: "hr-as-a-service",
                                                                i18nKey: "hr-as-a-service.help.feature".concat(index + 1, ".item").concat(j + 1)
                                                            })
                                                        ]
                                                    }, j);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                        to: "hrForm",
                        href: "#hrForm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                            variant: "hard",
                            schema: "brand2",
                            startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                            label: t("hr-as-a-service.hero.cta"),
                            href: "#hrForm"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/help/index.ts


;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/hero/Hero.styled.ts

function Hero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        " 0;\n\n  .stack {\n    margin: auto;\n    max-width: 1250px;\n\n    @media (max-width: ",
        ") {\n        gap: 1rem;\n    }\n  }\n  \n  .text {\n    margin: 5rem 0;\n\n    @media (max-width: ",
        ") {\n      margin: 1rem 0;\n    }\n\n    h2 strong {\n      color: ",
        ";\n    }\n\n    p {\n      font-size: 1.25rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .video {\n    iframe {\n        aspect-ratio 0.75;\n        border-radius: 1rem;\n        width: 528px;\n\n        @media (max-width: ",
        ") {\n          width: 100%;\n        }\n    }\n  }\n"
    ]);
    Hero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Hero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Hero_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea9a0c0-0"
})(Hero_styled_templateObject(), (0,theme/* color */.$_)("sun_100"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* color */.$_)("indigo_700"), (0,theme/* screen */.sp)("lg"));
var Logo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1ea9a0c0-1"
})(Hero_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/hero/Hero.tsx









var Hero = function() {
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_styled_Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* Stack */.Kq, {
                alignment: "center",
                gap: "7xl",
                className: "stack",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* StackItem */.vO, {
                        className: "text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                                as: "h1",
                                size: "7xl",
                                editorial: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "hr-as-a-service",
                                    i18nKey: "hr-as-a-service.hero.title"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.hero.desc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                to: "hrForm",
                                href: "#hrForm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                                    variant: "hard",
                                    schema: "brand2",
                                    startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                                    label: t("hr-as-a-service.hero.cta"),
                                    href: "#hrForm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* StackItem */.vO, {
                        className: "video",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/Success positive.svg")
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/hero/index.ts


;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/howIs/HowIs.styled.ts

function HowIs_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  padding: ",
        " 0;\n\n  h2 {\n    color: ",
        ";\n  }\n"
    ]);
    HowIs_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HowIs_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  column-gap: 1.25rem;\n  margin-top: 2rem;\n\n  @media (max-width: ",
        ") {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n"
    ]);
    HowIs_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HowIs_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h3 {\n    color: ",
        ";\n    margin-bottom: 0.5rem;\n    border-bottom: 2px solid ",
        ";\n    padding-bottom: 0.75rem;\n    gap: 0.5rem;\n    display: flex;\n    position: relative;\n\n    strong {\n      display: inline-block;\n      font-size: 1.25rem;\n      border-radius: 100%;\n      width: 2.25rem;\n      height: 2rem;\n      line-height: 2rem;\n      background: ",
        ";\n      color: #fff;\n      text-align: center;\n    }\n\n    &::after {\n      content: '';\n      border-right: 2px solid ",
        ";\n      border-bottom: 2px solid ",
        ";\n      width: 8px;\n      height: 8px;\n      position: absolute;\n      bottom: -6px;\n      right: 0;\n      transform: rotate(-45deg);\n    }\n  }\n\n  h4 {\n    margin-bottom: 0;\n  }\n\n  p {\n    font-size: 1.25rem;\n    line-height: 1.75;\n  }\n"
    ]);
    HowIs_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HowIs_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-left: 5rem;\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 1.25rem;\n    height: 1.25rem;\n    border: 10px solid ",
        ";\n    background: #01ffc6;\n    outline: 5px solid #01ffc6;\n    bottom: 0;\n    left: 0;\n    border-radius: 100%;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 1rem;\n    left: 0;\n    width: 5rem;\n    height: 5px;\n    background: ",
        ";\n  }\n"
    ]);
    HowIs_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HowIs_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 350px;\n"
    ]);
    HowIs_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var HowIs_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e26ba46-0"
})(HowIs_styled_templateObject(), (0,theme/* spacing */.W0)("xl6"), (0,theme/* color */.$_)("indigo_700"));
var HowIs_styled_Features = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e26ba46-1"
})(HowIs_styled_templateObject1(), (0,theme/* screen */.sp)("lg"));
var HowIs_styled_Feature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e26ba46-2"
})(HowIs_styled_templateObject2(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* color */.$_)("indigo_300"), (0,theme/* color */.$_)("indigo_700"), (0,theme/* color */.$_)("indigo_300"), (0,theme/* color */.$_)("indigo_300"));
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e26ba46-3"
})(HowIs_styled_templateObject3(), (0,theme/* color */.$_)("navy_700"), (0,theme/* color */.$_)("navy_700"));
var BadgeDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e26ba46-4"
})(HowIs_styled_templateObject4());

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/howIs/HowIs.tsx






var HowIs = function() {
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    var features = [
        {
            title: t("hr-as-a-service.how-is.feature1.title"),
            desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "hr-as-a-service",
                i18nKey: "hr-as-a-service.how-is.feature1.desc"
            })
        },
        {
            title: t("hr-as-a-service.how-is.feature2.title"),
            desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "hr-as-a-service",
                i18nKey: "hr-as-a-service.how-is.feature2.desc"
            })
        },
        {
            title: t("hr-as-a-service.how-is.feature3.title"),
            desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "hr-as-a-service",
                i18nKey: "hr-as-a-service.how-is.feature3.desc"
            })
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowIs_styled_Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* Stack */.Kq, {
                gap: "6xl",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Stack */.Kq, {
                        alignment: "center",
                        contentAlign: "center",
                        direction: "column",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                            as: "h2",
                            size: "5xl",
                            editorial: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.how-is.title"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HowIs_styled_Features, {
                        children: features.map(function(param, index) {
                            var title = param.title, desc = param.desc;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HowIs_styled_Feature, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* Header */.h4, {
                                        as: "h3",
                                        size: "2xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    "0",
                                                    index + 1
                                                ]
                                            }),
                                            " ",
                                            title
                                        ]
                                    }),
                                    desc
                                ]
                            }, title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* Stack */.Kq, {
                        alignment: "center",
                        contentAlign: "center",
                        direction: "row",
                        gap: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Badge */.Ct, {
                                    variant: "hard",
                                    schema: "active",
                                    bold: true,
                                    size: "s",
                                    label: t("hr-as-a-service.how-is.badge")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeDesc, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "hr-as-a-service",
                                    i18nKey: "hr-as-a-service.how-is.badge-desc"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/howIs/index.ts


// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(23467);
;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/successCases/SuccessCases.styled.ts

function SuccessCases_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        " 0;\n  color: #fff;\n"
    ]);
    SuccessCases_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuccessCases_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 55rem;\n  margin: auto;\n\n  h3 {\n    margin-top: 1.5rem;\n  }\n\n  p {\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n  }\n\n  span[mode='light'] {\n    background: #fff;\n  }\n"
    ]);
    SuccessCases_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SuccessCases_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: #fff;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  padding: 0.5rem;\n  font-weight: 900;\n  letter-spacing: 4px;\n  display: inline-flex;\n  border-radius: 5px;\n  word-break: break-word;\n"
    ]);
    SuccessCases_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SuccessCases_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 1rem;\n"
    ]);
    SuccessCases_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SuccessCases_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 2.5rem;\n  border-radius: 10px;\n  max-width: 60%;\n\n  @media (max-width: ",
        ") {\n    max-width: 100%;\n  }\n\n  h4 {\n    line-height: 1.25;\n  }\n"
    ]);
    SuccessCases_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  background-size: cover;\n  box-shadow: 0px 7.57px 11.35px 0px #261a191a;\n  box-shadow: 0px 3.03px 4.54px 0px #261a190d;\n  padding: 2.5rem;\n  border-radius: 10px;\n  min-height: 500px;\n\n  @media (max-width: ",
        ") {\n    padding: 0;\n    background: none !important;\n    min-height: auto;\n  }\n\n  h4 {\n    margin: 1.5rem 0;\n    color: #000;\n  }\n\n  h5 {\n    margin-bottom: 0;\n  }\n\n  p {\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var SuccessCases_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd117211-0"
})(SuccessCases_styled_templateObject(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* spacing */.W0)("xl4"));
var SuccessCases_styled_Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd117211-1"
})(SuccessCases_styled_templateObject1());
var SuccessCases_styled_Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd117211-2"
})(SuccessCases_styled_templateObject2(), (0,theme/* color */.$_)("indigo_700"));
var FeatureWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd117211-3"
})(SuccessCases_styled_templateObject3());
var FeatureContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd117211-4"
})(SuccessCases_styled_templateObject4(), (0,theme/* color */.$_)("sun_100"), (0,theme/* screen */.sp)("lg"));
var SuccessCases_styled_Feature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd117211-5"
})(_templateObject5(), (0,theme/* screen */.sp)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/successCases/SuccessCases.tsx









var SuccessCases = function(param) {
    var items = param.items;
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    var sliderSettings = {
        dots: true,
        arrows: false,
        speed: 300,
        slidesToShow: 1.65,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessCases_styled_Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessCases_styled_Intro, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                    as: "h3",
                    size: "5xl",
                    editorial: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "hr-as-a-service",
                        i18nKey: "hr-as-a-service.success-cases.title"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                children: items.map(function(param) {
                    var id = param.id, _attributes = param.attributes, title = _attributes.title, successCaseTitle = _attributes.successCaseTitle, successCaseUrl = _attributes.successCaseUrl, _image = _attributes.image, _data = _image.data, url = _data.attributes.url;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessCases_styled_Feature, {
                            style: {
                                backgroundImage: "url(".concat(url, ")")
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessCases_styled_Badge, {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                                        as: "h4",
                                        size: "3xl",
                                        children: successCaseTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                                        href: successCaseUrl,
                                        target: "_blank",
                                        schema: "brand2",
                                        variant: "hard",
                                        endIcon: pro_light_svg_icons/* faArrowRight */.eFW,
                                        size: "xs",
                                        label: t("hr-as-a-service.success-cases.cta")
                                    })
                                ]
                            })
                        })
                    }, id);
                })
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/successCases/index.ts


;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/whatIs/WhatIs.styled.ts

function WhatIs_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        " 0;\n\n  @media (max-width: ",
        ") {\n    padding: ",
        " 0;\n  }\n"
    ]);
    WhatIs_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhatIs_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 55rem;\n  margin: auto;\n\n  h3 {\n    margin-bottom: 0;\n  }\n\n  p {\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    WhatIs_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhatIs_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  column-gap: 1.25rem;\n\n  @media (max-width: ",
        ") {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n"
    ]);
    WhatIs_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhatIs_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  box-shadow: 0px 7.57px 11.35px 0px #261a191a;\n  box-shadow: 0px 3.03px 4.54px 0px #261a190d;\n  padding: 2.5rem;\n  border-radius: 10px;\n\n  h4 {\n    color: ",
        ";\n    margin-bottom: 0.5rem;\n    border-bottom: 4px solid ",
        ";\n    display: inline-flex;\n  }\n\n  h5 {\n    margin-bottom: 0;\n  }\n\n  p {\n  }\n"
    ]);
    WhatIs_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var WhatIs_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e6117f8-0"
})(WhatIs_styled_templateObject(), (0,theme/* color */.$_)("sun_100"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl2"));
var WhatIs_styled_Intro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e6117f8-1"
})(WhatIs_styled_templateObject1());
var WhatIs_styled_Features = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e6117f8-2"
})(WhatIs_styled_templateObject2(), (0,theme/* screen */.sp)("lg"));
var WhatIs_styled_Feature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e6117f8-3"
})(WhatIs_styled_templateObject3(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* color */.$_)("indigo_300"));

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/whatIs/WhatIs.tsx






var WhatIs = function() {
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    var features = [
        {
            position: "A",
            title: t("hr-as-a-service.what-is.feature1.title"),
            desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "hr-as-a-service",
                i18nKey: "hr-as-a-service.what-is.feature1.desc"
            })
        },
        {
            position: "B",
            title: t("hr-as-a-service.what-is.feature2.title"),
            desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "hr-as-a-service",
                i18nKey: "hr-as-a-service.what-is.feature2.desc"
            })
        },
        {
            position: "C",
            title: t("hr-as-a-service.what-is.feature3.title"),
            desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "hr-as-a-service",
                i18nKey: "hr-as-a-service.what-is.feature3.desc"
            })
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIs_styled_Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIs_styled_Intro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                            as: "h3",
                            size: "5xl",
                            editorial: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.what-is.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                            as: "h4",
                            size: "2xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.what-is.subtitle"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "hr-as-a-service",
                            i18nKey: "hr-as-a-service.what-is.desc"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                            as: "h4",
                            size: "2xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "hr-as-a-service",
                                i18nKey: "hr-as-a-service.what-is.for-you"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIs_styled_Features, {
                    children: features.map(function(param) {
                        var title = param.title, position = param.position, desc = param.desc;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIs_styled_Feature, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                                    as: "h4",
                                    size: "2xl",
                                    children: position
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Header */.h4, {
                                    as: "h5",
                                    size: "l",
                                    children: title
                                }),
                                desc
                            ]
                        }, title);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/sections/whatIs/index.ts


;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/HrAsAServicePage.tsx













var HrAsAServicePage = function(param) {
    var items = param.items;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dist/* useLocalStorage */._)("evaluateBoxClosed", false), 2), isClosed = ref[0], setIsClosed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        pageVariant: "light",
        hasScrollTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIs, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Evaluate, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Help, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowIs, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessCases, {
                    items: items
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {}),
                !isClosed && /*#__PURE__*/ (0,jsx_runtime.jsx)(EvaluateBox, {
                    onClick: function() {
                        return setIsClosed(true);
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/hrAsAService/index.ts


// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(63201);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(81192);
;// CONCATENATED MODULE: ./pages/hr-as-a-service.tsx









var HrAsAService = function(param) {
    var baseUrl = param.baseUrl, items = param.items;
    var t = (0,useI18n/* useI18n */.Q)("hr-as-a-service").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("hr-as-a-service.page_title"),
                url: app_urls/* APP_URLS.hrAsAService */.uu.hrAsAService,
                desc: t("hr-as-a-service.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_hr_as_a_service.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrAsAServicePage, {
                items: items
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var hr_as_a_service = (HrAsAService);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 57982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ f; },
/* harmony export */   "M": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&t(e,f);var o={};for(var a in e){var n=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(f.fields,a);(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8)(o,a,Object.assign(e[a]||{},{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map


/***/ }),

/***/ 33161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
/* harmony import */ var _hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57982);
var n=function(e,o){for(var n={};e.length;){var t=e[0],s=t.code,i=t.message,a=t.path.join(".");if(!n[a])if("unionErrors"in t){var u=t.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code}}else n[a]={message:i,type:s};if("unionErrors"in t&&t.unionErrors.forEach(function(r){return r.errors.forEach(function(r){return e.push(r)})}),o){var c=n[a].types,f=c&&c[t.code];n[a]=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .appendErrors */ .KN)(a,o,n,s,f?[].concat(f,t.message):t.message)}e.shift()}return n},t=function(r,t,s){return void 0===s&&(s={}),function(i,a,u){try{return Promise.resolve(function(o,n){try{var a=Promise.resolve(r["sync"===s.mode?"parse":"parseAsync"](i,t)).then(function(r){return u.shouldUseNativeValidation&&(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .validateFieldsNatively */ .M)({},u),{errors:{},values:s.raw?i:r}})}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r){if(function(r){return null!=r.errors}(r))return{values:{},errors:(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .toNestError */ .D)(n(r.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r}))}catch(r){return Promise.reject(r)}}};
//# sourceMappingURL=zod.module.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3955,1534,3467,625,4882,2987,6248,9774,2888,179], function() { return __webpack_exec__(50929); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);